import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import 'semantic-ui-css/components/table.min.css';
import { Button, Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import MyList from './list';

const FullWidth = styled.section`
    width: 100%;
    padding: 10px;
`;

class ProviderList extends MyList {

    entity = "provider";

    refresh() {
        var token = localStorage.getItem('adminToken')
        if (token && token !== 'undefined') {
            fetch(process.env.REACT_APP_API_URL + "mongol/providers", {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            })
            .then(res => {
                if (res.status === 401) {
                    this.setState({ redirect: this.loginUrl})
                } else {
                    res.json().then(res => {
                        console.log(res);
                        if (!res || !res.data) {
                            return;
                        }
                        let data: any[] = res.data;
                        data.forEach(b => b.confirmingDelete = false);
                        this.setState({ data: data });
                    })
                }
            })
            .catch(err => console.error(err));
        }
        else {
            this.setState({ redirect: this.loginUrl });
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <FullWidth>
                <h2>Нийлүүлэгч байгууллагууд</h2>
                {/* Нийт: {this.state?.data?.listCategories?.items.length} */}
                <Link to="/mongol/providers/new">
                    <Button basic color='orange'>Шинээр үүсгэх</Button>
                </Link>

                {this.state.errorMsg ? <div className="error-msg">
                    <Icon name="warning circle"/>&nbsp;
                    {this.state.errorMsg}
                </div> : null}

                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>№</Table.HeaderCell>
                            <Table.HeaderCell>Байгууллагын нэр</Table.HeaderCell>
                            {/* <Table.HeaderCell>Регистр</Table.HeaderCell> */}
                            {/* <Table.HeaderCell>Имэйл</Table.HeaderCell> */}
                            <Table.HeaderCell>Утас</Table.HeaderCell>
                            <Table.HeaderCell>Ажилтан</Table.HeaderCell>
                            <Table.HeaderCell>Зөвшөөрсөн</Table.HeaderCell>
                            <Table.HeaderCell>Идэвхитэй</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        { this.state?.data?.map((row: any, index: number) => {
                                return <Table.Row key={row.id}>
                                    <Table.Cell data-label="№">{ String(index+1) }</Table.Cell>
                                    <Table.Cell data-label="Байгууллагын нэр">
                                        <strong>
                                            <Link className="underline hover-blue" to={"/mongol/provider/" + row.id}>{ row.name }</Link>
                                        </strong>
                                    </Table.Cell>
                                    {/* <Table.Cell>{row.register}</Table.Cell> */}
                                    {/* <Table.Cell>{row.email}</Table.Cell> */}
                                    <Table.Cell data-label="Утас">{row.phone}</Table.Cell>
                                    <Table.Cell data-label="Ажилтан">
                                        <Link className="underline" to={"/mongol/provider-user/" + row.userId}>{row.ownName}</Link>
                                    </Table.Cell>
                                    <Table.Cell data-label="Зөвшөөрсөн"> { row.approved ? <Icon name="checkmark"/> : null } </Table.Cell>
                                    <Table.Cell data-label="Идэвхитэй"> { row.active ? <Icon name="checkmark"/> : null } </Table.Cell>
                                    <Table.Cell data-label="Үйлдэл">
                                        { row.confirmingDelete ? 
                                            <React.Fragment>
                                                <Button primary size='mini' onClick={() => this.delete(index)}>Устга</Button>
                                                <Button size='mini' onClick={() => this.toggleDelete(index)}>Болих</Button>
                                            </React.Fragment> :
                                            <Icon name="trash" className="cursor chef-icon-hover padding-5" onClick={() => this.toggleDelete(index)}/>
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            })
                        }
                    </Table.Body>
                </Table>
            </FullWidth>
        );
    }
}
            
export default ProviderList;
